// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0661868","754":"0a41352e"}[chunkId] + ".chunk.js";
};